import { z } from 'zod'

export const COACHING_YPO_OPS_CONTRACT_VERSION = '1.0.0' as const
export const coachingYpoOpsResponseSchema = z.unknown()
export type CoachingYpoOpsResponse = z.infer<typeof coachingYpoOpsResponseSchema>
